export const ETAPAS = [
  { key: 'nova_demanda', label: 'Nova Demanda', color: 'info' },
  { key: 'aprovada', label: 'Aprovada', color: 'primary' },
  { key: 'em_captacao', label: 'Em Captação', color: 'purple' },
  { key: 'em_edicao', label: 'Em Edição', color: 'warning' },
  { key: 'aguardando_solicitante', label: 'Aguardando Solicitante', color: 'warning' },
  { key: 'aguardando_aprovacao', label: 'Aguardando Aprovação', color: 'warning' },
  { key: 'pronta_para_publicar', label: 'Pronta para Publicar', color: 'info' },
  { key: 'publicado', label: 'Publicado', color: 'success' },
  { key: 'cancelada', label: 'Cancelada', color: 'danger' },
];

export const ETAPA_MAP = Object.fromEntries(ETAPAS.map((e) => [e.key, e]));

// CANAIS = ONDE a comunicação será publicada
export const CANAIS = [
  { key: 'insta_prefeitura', label: 'Instagram Prefeitura', icon: 'instagram' },
  { key: 'insta_secretaria', label: 'Instagram Secretaria', icon: 'instagram' },
  { key: 'insta_prefeito', label: 'Instagram Prefeito', icon: 'instagram' },
  { key: 'facebook', label: 'Facebook', icon: 'facebook' },
  { key: 'youtube', label: 'YouTube', icon: 'youtube' },
  { key: 'tiktok', label: 'TikTok', icon: 'tiktok' },
  { key: 'site', label: 'Site oficial', icon: 'globe' },
  { key: 'portais', label: 'Portais de Notícia', icon: 'newspaper' },
  { key: 'radio', label: 'Rádio', icon: 'radio' },
  { key: 'tv', label: 'TV', icon: 'tv' },
  { key: 'whatsapp', label: 'WhatsApp (transmissões)', icon: 'whatsapp' },
];

// TIPOS = FORMATO do conteúdo a ser produzido
export const TIPOS = [
  { key: 'foto', label: 'Foto' },
  { key: 'video', label: 'Vídeo' },
  { key: 'reel', label: 'Reel / Shorts' },
  { key: 'story', label: 'Story' },
  { key: 'audio', label: 'Áudio' },
  { key: 'entrevista', label: 'Entrevista' },
  { key: 'reportagem', label: 'Reportagem' },
  { key: 'arte', label: 'Arte / Design' },
  { key: 'texto', label: 'Texto / Release' },
  { key: 'nota_oficial', label: 'Nota oficial' },
  { key: 'live', label: 'Live / Transmissão' },
  { key: 'podcast', label: 'Podcast' },
  { key: 'cobertura', label: 'Cobertura de evento' },
];

export const APROVACOES = [
  { key: 'pendente', label: 'Pendente', color: 'warning' },
  { key: 'aprovado', label: 'Aprovado', color: 'success' },
  { key: 'reprovado', label: 'Reprovado', color: 'danger' },
];

export const PRIORIDADES = [
  { key: 'baixa', label: 'Baixa', color: 'default', dotColor: '#94a3b8' },
  { key: 'media', label: 'Média', color: 'info', dotColor: '#0369a1' },
  { key: 'alta', label: 'Alta', color: 'warning', dotColor: '#d97706' },
  { key: 'urgente', label: 'Urgente', color: 'danger', dotColor: '#dc2626' },
];
export const PRIORIDADE_MAP = Object.fromEntries(PRIORIDADES.map((p) => [p.key, p]));

export const APROVACAO_PUBLICA_STATUS = {
  pendente: { label: 'Aguardando decisão', color: 'warning' },
  aprovada: { label: 'Aprovada', color: 'success' },
  alteracao_solicitada: { label: 'Alteração solicitada', color: 'warning' },
  cancelada: { label: 'Cancelada', color: 'default' },
  expirada: { label: 'Expirada', color: 'default' },
};

export function initials(nome) {
  if (!nome) return '?';
  const parts = nome.trim().split(/\s+/);
  return (parts[0][0] + (parts[parts.length - 1][0] || '')).toUpperCase();
}
